import { tryCheckPermForOneLink } from '../actions/publicActions';
import { shouldCheckPermForLink } from '../utils/shouldCheckPermForLink';
import { getAllRecipients } from '../utils/getAllRecipients';
import { updateRecipientsOnLink } from '../utils/updateRecipientsOnLink';
import { lazyGetSharingTipRecipientInfo } from 'owa-link-data';
import { RecipientMemberInfo } from 'owa-recipient-types/lib/types/RecipientMemberInfo';
import { SharingTipRecipientInfo } from 'owa-sharing-data';
import { trace } from 'owa-trace';
import { orchestrator } from 'satcheljs';

orchestrator(tryCheckPermForOneLink, async actionMessage => {
    if (!shouldCheckPermForLink(actionMessage.linkId)) {
        return;
    }

    trace.info('RecipientPermission: tryCheckPermForOneLink');
    const getSharingTipRecipientInfo = await lazyGetSharingTipRecipientInfo.import();
    const recipientInfos: SharingTipRecipientInfo[] = getSharingTipRecipientInfo(
        actionMessage.recipientContainers,
        actionMessage.fromAddress
    );

    const allRecipients: RecipientMemberInfo[] = await getAllRecipients(
        [actionMessage.linkId],
        recipientInfos,
        actionMessage.composeId,
        actionMessage.isCalendar
    );

    if (allRecipients.length === 0) {
        return;
    }

    await updateRecipientsOnLink(actionMessage.linkId, allRecipients, actionMessage.composeId);
});
